<template lang="pug">
ul.nav.nav-tabs
  slot(:class="typeClasses")
</template>

<script>
export default {
  name: 'AppNav',
  props: {
    typeClasses: {
      type: String,
      default: '',
    },
  },
};
</script>
